module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8557/img/blobsLeft.png"